<template>
  <div id="signal-lamp-ct" v-if="show">
    <!-- 老师 -->
    <div
      id="signal-lamp"
      class="signal-lamp-teacher"
      v-if="!student_type && !isClickDetail"
    >
      <i class="close" @click="closeJude"></i>
      <p class="lamp-title">交通信号灯</p>
      <p class="lamp-intro">
        交通信号灯：学生可评价自己对课程的理解，采用合作学习策略，让学生一起学习，帮助彼此掌握内容，互相评价彼此的学习，并引导同伴进行卓有成效的思考。
      </p>
      <div
        class="lamp-count"
        :class="{
          hidden:
            data.data.is_open == 2 ||
            data.data.is_open == 3 ||
            data.data.is_open == 4,
        }"
      >
        <div>
          全班人数： <span>{{ data.data.student_count }}</span>
        </div>
        <div>
          已投人数： <span>{{ data.data.vote_student_count }}</span>
        </div>
        <div>
          未投人数： <span>{{ data.data.not_vote_student_count }}</span>
        </div>
      </div>
      <div class="lamp-tools">
        <div
          class="item"
          v-for="(value, index) in data.data.colors"
          :key="index"
        >
          <div
            class="item-son"
            :class="colorChoose(value.color)"
            @click="detail(value)"
          >
            <div class="item-son-1">
              <div class="item-son-2">
                <span class="title">{{ value.count }}</span>
                <span class="count">{{ value.rate }}%</span>
                <span
                  class="check"
                  :class="{
                    'check-active':
                      data.data.is_open == 1 || data.data.is_open == 0,
                  }"
                  >查看</span
                >
              </div>
            </div>
          </div>
          <div class="item-font">{{ value.color_name }}</div>
        </div>
      </div>
      <div class="lamp-start">
        <span v-if="data.data.is_open == 2" @click="start">开始</span>
        <span v-if="data.data.is_open == 1" @click="end">结束</span>
        <span class="again" v-if="data.data.is_open == 0" @click="again"
          >再来一次</span
        >
        <span v-if="data.data.is_open == 0" @click="close">关闭</span>
      </div>
    </div>
    <!-- 老师详情 -->
    <div
      id="signal-lamp"
      class="signal-lamp-teacher single-detail"
      v-if="!student_type && isClickDetail"
    >
      <i class="close" @click="closeJude"></i>
      <p class="lamp-title">投票详情</p>
      <div class="detail-title">
        <div class="left">
          <i :class="colorChoose(singleDetailData.color)"></i>
          <span>选项：{{ singleDetailData.color_name }}</span>
        </div>
        <div class="right">
          已投{{ singleDetailData.count }}人, {{ singleDetailData.rate }}%
        </div>
      </div>
      <div class="detail-content">
        {{ singleDetailData.name_arr.join("、") }}
      </div>
      <div class="back-detail" @click="backDeatail">返回</div>
    </div>
    <!-- 学生 -->
    <div id="signal-lamp" class="signal-lamp-student" v-if="student_type">
      <!-- <i class="close" @click="close"></i> -->
      <p class="lamp-title">交通信号灯</p>
      <p class="lamp-intro">
        交通信号灯：学生可评价自己对课程的理解，采用合作学习策略，让学生一起学习，帮助彼此掌握内容，互相评价彼此的学习，并引导同伴进行卓有成效的思考。
      </p>
      <div class="lamp-count" v-if="data.data.is_open == 0">
        <div>
          全班人数： <span>{{ data.data.student_count }}</span>
        </div>
        <div>
          已投人数： <span>{{ data.data.vote_student_count }}</span>
        </div>
        <div>
          未投人数： <span>{{ data.data.not_vote_student_count }}</span>
        </div>
      </div>
      <div class="lamp-tools">
        <div
          class="item"
          v-for="(value, index) in data.data.colors"
          :key="index"
          @click="studentChooseItem(value.color)"
          :class="{ active: value.color == studentChooseType }"
        >
          <div class="item-son" :class="colorChoose(value.color)">
            <div class="item-son-1">
              <div class="item-son-2">
                <span class="title" v-if="data.data.is_open == 0">{{
                  value.count
                }}</span>
                <span class="count" v-if="data.data.is_open == 0"
                  >{{ value.rate }}%</span
                >
                <i
                  class="choose-ico"
                  :class="{ 'icon-active': data.data.is_open == 0 }"
                ></i>
              </div>
            </div>
          </div>
          <div class="item-font">{{ value.color_name }}</div>
        </div>
      </div>
      <div class="lamp-start">
        <span
          v-if="data.data.is_open == 1 && !studentFinish"
          :class="{ 'opaci-active': studentChooseType == 0 }"
          @click="studentChoose"
          >确认投票</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getStuBookScreen } from "./indexApi";
export default {
  name: "signal-lamp-ct",
  data() {
    return {
      //是否显示信号灯
      show: false,
      //是否为学生类型
      student_type: false,
      //更新组件key
      key: 0,
      //result数据
      data: null,
      //学生选中类型
      studentChooseType: 0,
      //学生是否已经投票
      studentFinish: false,
      //老师是否点击详情状态
      isClickDetail: false,
      //老师是否点击详情
      singleDetailData: null,
      //信号灯id
      id: 0,
      //老师详情类型
      detailType: 0,
    };
  },
  watch: {
    receData(val) {
      console.log(val);
      this.detailEvent(val);
    },
  },
  computed: {
    receData() {
      return this.$store.state.interaction.lamp_Receive;
    },
  },
  methods: {
    backDeatail() {
      this.isClickDetail = false;
      this.detailType = 0;
    },
    detail(value) {
      console.log(value);
      let status = this.data.data.is_open;
      if (status == 2) {
        this.$toast("请先开始投票");
        return;
      }
      if (value.count == 0) {
        this.$toast("该选项暂无投票记录");
        return;
      }
      this.detailType = value.color;
      if (status == 1 || status == 0) {
        this.isClickDetail = true;
        this.updateDetail();
      }
    },
    updateDetail() {
      if (status == 1 || status == 0) {
        let arr = [];
        if (this.detailType == 0) {
          return;
        }
        for (let v of this.data.data.colors) {
          if (this.detailType == v.color) {
            this.singleDetailData = v;
            for (let item of this.singleDetailData.single_details) {
              arr.push(item.user_name);
            }
          }
        }
        console.log(this.detailType);
        this.singleDetailData["name_arr"] = arr;
        console.log(this.singleDetailData);
      }
    },
    initData() {
      this.studentChooseType = 0;
      this.studentFinish = false;
      this.detailType = 0;
    },
    studentChooseItem(type) {
      console.log(type);
      if (this.data.data.is_open == 0) {
        return;
      }
      if (this.studentFinish) {
        console.log("你已经投票");
        return;
      }
      this.studentChooseType = type;
    },
    studentChoose() {
      if (!this.studentChooseType) {
        this.$toast("请先投票");
        console.log("请先投票");
        return;
      }
      localStorage.setItem("lamp_student_choose_type", this.studentChooseType);
      this.$store.commit(
        "sendlampevent",
        this.key + "&event_traffic_light_vote"
      );
      this.key++;
    },
    again() {
      this.$store.commit(
        "sendlampevent",
        this.key + "&event_traffic_light_click"
      );
      this.key++;
      this.$flydata.flydataTrack(249); //信号灯-再来一次埋点
    },
    end() {
      this.$store.commit(
        "sendlampevent",
        this.key + "&event_traffic_light_stop"
      );
      this.key++;
    },
    start() {
      this.$store.commit(
        "sendlampevent",
        this.key + "&event_traffic_light_start"
      );
      this.key++;
      this.$flydata.flydataTrack(248); //信号灯埋点
    },
    close() {
      this.show = false;
      this.isClickDetail = false;
      this.$store.commit(
        "sendlampevent",
        this.key + "&event_traffic_light_close"
      );
      this.key++;
    },
    closeJude() {
      if (this.data.data.is_open == 1) {
        this.$confirm(
          "关闭后，结束投票，学生端将同步关闭该互动。",
          "确定要关闭吗",
          {
            customClass: "akadm-confirm-box",
            confirmButtonText: "确定",
            ancelButtonText: "取消",
            closeOnClickModal: false,
          }
        )
          .then(() => {
            this.close();
          })
          .catch(() => {});
        return;
      }
      this.close();
    },
    colorChoose(type) {
      let colorObj = {
        1: "green",
        2: "yellow",
        3: "red",
      };
      return colorObj[type];
    },
    studentResult(data) {
      if (data) {
        for (let value of data) {
          console.log(value.user_id);
          if (value.user_id == this.$cookies.get("user_id")) {
            this.studentChooseType = value.color;
            this.studentFinish = true;
          }
        }
      }
    },
    detailEvent(val) {
      if (
        val.data.teacher_id &&
        this.$cookies.get("user_type") == this.identity.teacher
      ) {
        if (this.$cookies.get("user_id") != val.data.teacher_id) {
          console.log("不是该老师操作");
          return;
        }
      }
      this.init(val);
      //1:开启 0:结束 2：初始化 3：关闭 4：未点击
      switch (val.data.is_open) {
        case 0:
          this.show = true;
          if (this.student_type) {
            this.initData();
            this.studentResult(this.data.data.details);
          }
          console.log("00000");
          break;
        case 1:
          this.show = true;
          console.log(this.studentChooseType);
          console.log(this.studentFinish);
          if (this.student_type) {
            this.studentResult(this.data.data.details);
          }
          console.log("11111");
          break;
        case 2:
          if (this.student_type) {
            this.show = false;
            this.initData();
            return;
          }
          this.show = true;
          console.log("22222");
          break;
        case 3:
          this.show = false;
          console.log("333333");
          break;
        case 4:
          this.show = false;
          if (this.student_type) {
            this.initData();
          }
          console.log("444444");
          break;
        default:
          console.log("信号灯返回结果没有匹配");
          break;
      }
    },
    //获取麦穗接口
    getMaiSuiSwitch() {
      getStuBookScreen()
        .then((res) => {
          if (res.errCode == 0) {
            // this.getDeviceInfo('2') 传参代表为过滤非麦穗平板
            if (!res.data.status || !this.getDeviceInfo("2")) {
              this.show = true;
            } else {
              this.show = false;
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    init(val) {
      this.student_type =
        this.identity.student == this.$cookies.get("user_type") ? true : false;
      if (this.key > 10) {
        this.key = 0;
      }
      this.data = val;
      if (this.data.data.id != this.id && this.student_type) {
        this.id = this.data.data.id;
        this.initData();
      }
      this.updateDetail();
    },
  },
  created() {},
  components: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
#signal-lamp-ct {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba($color: #000000, $alpha: 0.2);
  .single-detail {
    .back-detail {
      position: absolute;
      bottom: 0.24rem;
      right: 0.24rem;
      width: 0.65rem;
      height: 0.32rem;
      text-align: center;
      line-height: 0.32rem;
      background: #fafafa;
      border: 0.01rem solid #c0ccda;
      font-size: 0.14rem;
      font-weight: 400;
      color: #475669;
      cursor: pointer;
      border-radius: 0.02rem;
    }
    .detail-title {
      overflow: hidden;
      margin-top: 0.22rem;
      padding-right: 0.4rem;
      .left {
        display: flex;
        align-items: center;
        float: left;
        i {
          display: inline-block;
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.15rem;
          border-radius: 50%;
        }
        .green {
          background: rgba(68, 215, 182, 1);
        }
        .yellow {
          background: rgba(252, 202, 30, 1);
        }
        .red {
          background: rgba(255, 53, 74, 1);
        }
        span {
          font-size: 0.18rem;
          font-weight: bold;
          color: #000000;
        }
      }
      .right {
        float: right;
        font-size: 0.18rem;
        font-weight: bold;
        color: #000000;
      }
    }
    .detail-content {
      margin-top: 0.22rem;
      width: 95%;
      /*width: 7.76rem;*/
      // height: 1.92rem;
      background: #f3f6f9;
      border-radius: 0.03rem;
      font-size: 0.2rem;
      font-weight: 400;
      padding: 0.16rem;
      line-height: 0.4rem;
      max-height: 2.5rem;
      overflow: auto;
      color: rgba(0, 0, 0, 0.87);
    }
  }
  .signal-lamp-teacher {
    .item-son-2 {
      padding-bottom: 0.45rem !important;
    }
    .item-son {
      cursor: pointer;
    }
  }
  .signal-lamp-student {
    width: 4rem;
    height: 3.12rem;
    padding-left: 0.16rem;
    .lamp-count {
      padding-left: 0.16rem;
      font-size: 0.13rem;
      margin-top: 0.2rem;
      padding-right: 0.32rem;
      div {
        margin-right: 0.24rem;
      }
      div:nth-of-type(3n) {
        margin-right: 0;
      }
    }
    .lamp-title {
      margin-top: 0.16rem;
      font-size: 0.16rem;
    }
    .lamp-intro {
      font-size: 0.13rem;
      margin-top: 0.1rem;
      padding-right: 0.16rem;
    }
    .lamp-start {
      padding-right: 0.16rem;
      span {
        width: 0.81rem;
        height: 0.29rem;
        line-height: 0.29rem;
        background: #027bfe;
        border-radius: 0.03rem;
        font-size: 0.13rem;
      }
      .opaci-active {
        opacity: 0.65;
      }
    }
    .lamp-tools {
      padding-right: 0.16rem;
      margin-top: 0.24rem;
      margin-bottom: 0.2rem;
      .item {
        .item-font {
          width: 0.4rem;
          height: 0.2rem;
          line-height: 0.2rem;
          background: #d5dce3;
          font-size: 0.1rem;
          margin-top: 0.08rem;
          border-radius: 0.12rem;
        }
        .item-son {
          width: 0.88rem;
          height: 0.88rem;
          .item-son-1 {
            width: 0.8rem;
            height: 0.8rem;
          }
          .item-son-2 {
            width: 0.68rem;
            height: 0.68rem;
            position: relative;
          }
          .title {
            font-size: 0.2rem;
          }
          .count {
            font-size: 0.13rem;
          }
          // .choose-ico {
          //   display: inline-block;
          //   width: 0.32rem;
          //   height: 0.32rem;
          //   background: url("../../assets/images/tick_ico.svg") no-repeat center center;
          // }
          .icon-active {
            position: absolute;
            bottom: 0;
            // display: inline-block;
            width: 0.16rem;
            height: 0.16rem;
            // background: url("../../assets/images/tick_ico.svg") no-repeat center center;
            // background-size: 100% 100%;
            left: 0;
            right: 0;
            margin: 0 auto;
          }
        }
      }
      .active {
        .choose-ico {
          display: inline-block;
          width: 0.32rem;
          height: 0.32rem;
          background: url("../../assets/images/tick_ico.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
      }
    }
  }
}
#signal-lamp {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 8.46rem;
  height: 4.58rem;
  padding-left: 0.3rem;
  z-index: 1999;
  background: #fff;
  .close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background: url("../../assets/images/close_ico_2.svg") no-repeat center
      center;
  }
  .lamp-count {
    display: flex;
    margin-top: 0.2rem;
    padding-right: 0.3rem;
    margin-top: 0.24rem;
    justify-content: center;
    font-size: 0.18rem;
    font-weight: bold;
    color: #333333;
    div {
      margin-right: 0.32rem;
      span {
        color: #037bfe;
      }
    }
    div:nth-of-type(3n) {
      margin-right: 0;
    }
  }
  .hidden {
    visibility: hidden;
  }
  .lamp-tools {
    width: 100%;
    // height: 2rem;
    padding-right: 0.3rem;
    margin-top: 0.16rem;
    margin-bottom: 0.26rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      text-align: center;
      .item-font {
        // width: 0.6rem;
        // height: 0.24rem;
        // line-height: 0.24rem;
        // font-size: 0.15rem;
        // font-weight: bold;
        // color: #333333;
        // background: #D5DCE3;
        // border-radius: 0.12rem;
        margin-top: 0.12rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .item-son {
        display: inline-flex;
        align-items: center;
        // flex-direction: column;
        justify-content: center;
        width: 1.66rem;
        height: 1.66rem;
        border-radius: 50%;
        span {
          // color: #fff;
          color: #000000;
        }
        .title {
          font-size: 0.44rem;
          font-weight: bold;
        }
        .count {
          font-size: 0.18rem;
          font-weight: bold;
        }
        .check {
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          bottom: 0.14rem;
          display: inline-block;
          width: 0.44rem;
          height: 0.24rem;
          border-radius: 0.12rem;
          opacity: 0.39;
          border: 0.01rem solid #ff7281;
          font-size: 0.12rem;
          font-weight: 400;
          color: #000000;
          text-align: center;
          line-height: 0.24rem;
          cursor: pointer;
        }
        .check-active {
          opacity: 1;
        }
        .item-son-1 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
        }
        .item-son-2 {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          width: 1.34rem;
          height: 1.34rem;
          border-radius: 50%;
        }
      }
      .green {
        background: rgba(68, 215, 182, 0.4);
        .item-son-1 {
          background: rgba(68, 215, 182, 1);
        }
        .item-son-2 {
          background: linear-gradient(180deg, #7bffeb 0%, #44d8b8 100%);
        }
        .check {
          border: 0.01rem solid #62eccd;
          background: #13c89f;
        }
      }
      .yellow {
        background: rgba(252, 202, 30, 0.4);
        .item-son-1 {
          background: rgba(252, 202, 30, 1);
        }
        .item-son-2 {
          background: linear-gradient(180deg, #ffe280 0%, #fcca1e 100%);
        }
        .check {
          background: #fcc405;
          border: 0.01rem solid #ffe17b;
        }
      }
      .red {
        background: rgba(255, 53, 74, 0.4);
        .item-son-1 {
          background: rgba(255, 53, 74, 1);
        }
        .item-son-2 {
          background: linear-gradient(180deg, #ff808d 0%, #ff354a 100%);
        }
        .check {
          background: #f5152d;
          border: 0.01rem solid #ff7281;
        }
      }
    }
  }
  .lamp-start {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0.3rem;
    span {
      width: 0.81rem;
      height: 0.32rem;
      background: #037bfe;
      border-radius: 0.03rem;
      font-size: 0.15rem;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      line-height: 0.32rem;
    }
    .again {
      margin-right: 0.24rem;
      color: #037bfe;
      background: #ffffff;
      border: 0.01rem solid #037bfe;
      border-radius: 0.03rem;
    }
  }
  .lamp-title {
    font-weight: bold;
    font-size: 0.18rem;
    color: #202020;
    margin-top: 0.3rem;
  }
  .lamp-intro {
    padding-right: 0.4rem;
    font-size: 0.16rem;
    color: #475669;
    margin-top: 0.12rem;
  }
}
@media screen and (max-width: 846px) {
  .signal-lamp-teacher {
    width: 5.46rem !important;
    .lamp-tools {
      margin-bottom: 0.24rem !important;
    }
  }
}
</style>
